import React from "react";
import { FaTrash, FaTimes, FaExclamationTriangle } from "react-icons/fa";
import "./PinMessageModal.css";

const DeleteMessageModal = ({ message, onConfirm, onClose }) => {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content delete-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>
            <FaTrash /> Delete Message
          </h3>
          <button onClick={onClose} className="btn-close-modal">
            <FaTimes />
          </button>
        </div>

        <div className="modal-body">
          <div className="warning-box">
            <FaExclamationTriangle />
            <p>Are you sure you want to delete this message?</p>
          </div>

          {message.content && (
            <div className="message-preview">
              <p>"{message.content.substring(0, 100)}..."</p>
              <small>by {message.sender?.name || "Unknown"}</small>
            </div>
          )}

          <p className="warning-text">
            This action cannot be undone. The message will be permanently
            deleted.
          </p>
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="btn-cancel">
            Cancel
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            className="btn-confirm btn-danger"
          >
            Delete Message
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteMessageModal;
